/**
 * The inbox's order (PRD-0075 R-B5): newest learned first, or the most severe first.
 */
import { useTranslation } from 'react-i18next'
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group'
import type { AlertSort } from '@/services/api/case-monitor'

const SORT = 'cases.monitor.alert.sort'
const SORTS: readonly AlertSort[] = ['date', 'severity']

export interface AlertSortControl {
  value: AlertSort
  onChange: (value: AlertSort) => void
}

export function AlertSortToggle({ value, onChange }: AlertSortControl) {
  const { t } = useTranslation()
  return (
    <ToggleGroup
      type="single"
      variant="outline"
      size="sm"
      value={value}
      aria-label={t(`${SORT}.label`)}
      onValueChange={next => {
        const picked = SORTS.find(sort => sort === next)
        if (picked) onChange(picked)
      }}
    >
      {SORTS.map(sort => (
        <ToggleGroupItem key={sort} value={sort} className="px-2.5 text-xs">
          {t(`${SORT}.${sort}`)}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  )
}
